export default __webpack_public_path__ + "static/setup-and-configuration-custom-titles-select-f3010747d7ad7613ae3f162a417a8758.mp4";